import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Link, Redirect, NavLink, HashRouter } from "react-router-dom";
import CKEditor from '@ckeditor/ckeditor5-react';
import CKEditor4 from "react-ckeditor-component";
import ClassicEditor from 'react-ckeditor5-classic-font-build';
import Header from './../../Header';
import HeaderMob from './../../HeaderMob';
import $ from 'jquery';
import CryptoJS from 'crypto-js';
import config from 'react-global-configuration';
import { Multiselect } from 'multiselect-react-dropdown';
ClassicEditor.defaultConfig = {
    fontBackgroundColor: {
        colors: [
            {
                color: 'rgb(230, 230, 77)',
                label: 'Yellow',
                colorButton_enableAutomatic: false
            }
        ]
    },
    toolbar: {
        items: [
            //        'bold',
            //        'italic',
            //        '|',
            //        'bulletedList',
            //        'numberedList',
            //        '|',
            //        'indent',
            //        'outdent',
            //        '|',
            //        'fontcolor',
            'fontbackgroundcolor',
        ]
    },
    language: 'en'
};
class UpdateChat extends Component {
    constructor(props) {
        super(props);
        var has_local_data = localStorage.getItem('encdata') ? 1 : 0;
        var localdata = has_local_data ? this.decrypt(localStorage.getItem('encdata'), 0) : '';
        this.state = {
            note_history: [],
            notes: [],
            owner_name: '',
            formatted_owners: [],
            note: '',
            owners: [],
            all_tags: [],
            errors: {},
            visitor_name: '',
            status: '',
            visitor_email: '',
            visitor_ip: '',
            visitor_country_name: '',
            visitor_region: '',
            visitor_city: '',
            tags: [],
            apiUrl: this.decryptconfigdata('apiUrl'),
            userId: has_local_data ? localdata.user_id : '',
            userName: has_local_data ? localdata.user_name : '',
            userAuthKey: has_local_data ? localdata.user_key : '',
            ChatEdit: localStorage.getItem('chat_dtls'),
            message: '',
            getFilters: [],
            prodname: [],
            podname: [],
            platname: [],
            featurename: [],
            count_prod: [],
            count_pod: [],
            count_platfrom: [],
            count_feature: [],
            ProductNameId: [],
            FeatureNameId: [],
            PlatformNameId: [],
            pods: [],
            featureList:[],
            selected_prods: ''
        }
        this.onChange = this.onChange.bind(this);
        this.AddNote = this.AddNote.bind(this);
        this.ckOnChange1 = this.ckOnChange1.bind(this);
        this.multiselectProductName = React.createRef();
        this.multiselectPodName = React.createRef();
        this.multiselectFeatureName = React.createRef();
    }

    decryptconfigdata(configkey) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return plaintext;
    }

    decrypt(findresponse, flg) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var res = flg ? findresponse.encdata : findresponse;
        var bytes = CryptoJS.AES.decrypt(res, key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(plaintext);
    }
    rawjsonparse(findresponse, flg) {
        return findresponse;
    }

    goBack() {
        window.history.back();
    }
    ckOnChange1(evt) {
        var ckContent = evt.editor.getData();
        if (this.state.note.toLowerCase() != ckContent.toLowerCase()) {
            this.setState({
                note: ckContent
            })
            var obj = this;
            setTimeout(function () {
                ckContent = ckContent.replace(/<\/p>$/, ""); //remove last </p>
                var nameRegex = /@[a-zA-Z]+$/;
                var matches = ckContent.match(nameRegex); //select characters having @
                if (matches && matches.length > 0) {
                    var indx = matches['index'];
                    var query = matches[0].replace('@', '');
                    if (query) {
                        var result = [];
                        var filterObj = obj.state.owners.filter(function (e) {
                            if (e.name.toLowerCase().includes(query.toLowerCase())) {
                                result.push(e.name);
                            }
                        });
                        var mtchitems = '';
                        if (result.length > 0) {
                            for (var i in result) {
                                mtchitems += '<li class="auto-suggest-li" style="padding:5px;cursor:pointer;background:#ccc;margin-bottom:1px;" >' + result[i] + '</li>';
                                if (i == result.length - 1) {
                                    mtchitems = '<ul style="list-style:none" class="auto-suggest-ul">' + mtchitems + '</ul>';
                                    document.getElementById('note_autoseggestion').innerHTML = mtchitems;
                                    $('.auto-suggest-li').on('click', function (event) {
                                        var final_string = ckContent.substring(0, indx) + "@" + event.target.innerText.trim();
                                        evt.editor.setData(final_string);
                                        obj.setState({
                                            note: final_string,
                                        })

                                        document.getElementById('note_autoseggestion').innerHTML = "";
                                        evt.editor.focus();
                                    });
                                }
                            }
                        } else {
                            document.getElementById('note_autoseggestion').innerHTML = "";
                        }
                    }
                } else {
                    document.getElementById('note_autoseggestion').innerHTML = "";
                }
            }, 300);
        } else {
            evt.editor.focus();
        }
    }
    AddNote() {
        let errors = {};
        document.getElementById("add_note").innerHTML = "Sending....";
        const fd = new FormData;
        document.getElementById("add_note").disabled = true;
        fd.append('note', this.state.note);
        fd.append('title', this.state.title);
        fd.append('selected_prods', this.state.selected_prods);
        fd.append('transcript_id', this.props.match.params.transcriptId);
        fetch(this.state.apiUrl + '/ErRest/AddChatNote/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
            method: 'POST',
            dataType: 'json',
            body: fd,
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
               // findresponse = this.decrypt(findresponse, 1);
                document.getElementById("add_note").disabled = false;
                document.getElementById("add_note").innerHTML = "Add Note";
                if (findresponse.code == 200) {
                    this.setState({ message: findresponse.msg }, function () {
                        errors["note"] = "";
                        this.setState({ errors: errors, note: '' });
                        window.location.href = '/EditChat/' + this.props.match.params.transcriptId;
                    });
                } else {
                    errors["note"] = findresponse.msg;
                    this.setState({ errors: errors });
                    this.setState({ message: findresponse.msg })
                }
            })
    }

    getHistoryDesc(type, old_value, new_value) {
        if (type == 2) {
            return ''
        } else if (type == 4) {
            return (
                <Link to={`/ChatHistoryRevision/${this.props.match.params.transcriptId}/noteId/${old_value}`} name={"max"} target="_blank"><span className="color-sky">View Revision</span></Link>
            )
        } else if (type == 5) {
            return old_value + " => " + new_value
        } else if (type == 6) {
            return old_value + " => " + new_value
        } else if (type == 7 || type == 3 || type == 8 || type == 9) {
            return old_value ? old_value + " => " + new_value : "' ' =>" + new_value;
        }
    }

    NoteEditCondition(id, note) {
        return (
            <a href="javascript:void(0)" onClick={() => this.setNote(id, note)}> <i class="fa fa-edit"></i></a>
        )
    }

    setNote(id, note) {
        localStorage.setItem('ticket_note', note);
        this.props.history.push('/NoteChatEdit/' + id);
    }

    getHistoryTitle(type, old_value, new_value) {
        if (type == 1) {
            return 'Chat Transcript Updated'
        } else if (type == 2) {
            return ('Note Added : ' + new_value)
        } else if (type == 4) {
            return ('Note Updated : ' + old_value)
        } else if (type == 3) {
            return ('Product Updated')
        } else if (type == 5) {
            return ('Lead Name Changed')
        } else if (type == 6) {
            return ('Summary Updated')
        }else if (type == 7) {
            return ('Pod Updated')
        }else if (type == 8) {
            return ('Feature Updated')
        }else if (type == 9) {
            return ('Platform Updated')
        }
    }

    getchatDetails() {
        $(document).ready(function () {
            $('.loader-new').removeClass('hidden');
            $('.intranet_body').addClass('hidden');
        });

        fetch(this.state.apiUrl + '/ErRest/EditChat/id/' + this.props.match.params.transcriptId + '/userAuthKey/' + this.state.userAuthKey)
            .then((Response) => Response.json())
            .then((findresponse) => {
                //findresponse = this.decrypt(findresponse, 1);
                console.log(findresponse);
                $(document).ready(function () {
                    $('.loader-new').addClass('hidden');
                    $('.intranet_body').removeClass('hidden');
                });

                let data = findresponse.data;

                this.setState({
                    prodname: data.product_name,
                    podname: data.pod_name,
                    platname: data.app_name,
                    featurename: data.feature,
                    ChatEdit: findresponse.chat_transcript,
                    visitor_name: findresponse.visitor_name,
                    title: findresponse.title,
                    visitor_email: findresponse.visitor_email,
                    visitor_ip: findresponse.visitor_ip,
                    visitor_country_name: findresponse.visitor_country_name,
                    visitor_region: findresponse.visitor_region,
                    visitor_city: findresponse.visitor_city,
                    ProductNameId: findresponse.product,
                    PlatformNameId: findresponse.platform,
                    FeatureNameId: findresponse.feature,
                    pods: findresponse.pod,
                    count_prod: findresponse.count_prod,
                    count_platform: findresponse.count_platform,
                    count_feature: findresponse.count_feature,
                    count_prd: findresponse.count_pod,
                    selected_prods: findresponse.selected_prods,
                    transcript_id: findresponse.transcript_id,
                    formatted_owners: findresponse.formatted_owners,
                    owners: findresponse.owners,
                    notes: findresponse.notes,
                    note_history: findresponse.chat_history_table,
                    scrol: this.state.scrol + 1
                })


                if (this.state.scrol <= 2) {

                    const { location: { pathname, hash } } = this.props;
                    const element = document.getElementById(hash.replace("#", ""));

                    setTimeout(() => {
                        window.scrollTo({
                            behavior: element ? "smooth" : 'auto',
                            top: element ? element.offsetTop : 0
                        })
                    })
                }
                else {
                    return false;
                }

            });
    }



    componentDidMount() {
        $(document).ready(function () {
            $('#cke_1_top').css('display', 'none');
            $("#show_dialog").css("display", "none");

            $('.ck-editor__main').on("keydown keyup", function (event) {
                if (event.which === 8 || event.which == 46) {
                    event.stopImmediatePropagation();
                    event.preventDefault();
                }
                event.preventDefault();
                $("#show_dialog").show();
                setTimeout(function () {
                    $("#show_dialog").fadeOut("hide", function () {
                    });
                }, 3000);
            });
            $('.ck-editor__main').bind("contextmenu", function (e) {
                return false;
            });
        });
    }

    onSelect = (selectedList, selectedItem) => {
        if (this.multiselectProductName.current.state.selectedValues.length > 4) {
            this.setState({
                customerclass: true
            })
        }
        var obj = {};
        var selected_val = selectedItem.product_name;
        obj['product_name'] = selected_val;
        this.state.ProductNameId.push(obj);
    }
    onSelectPod = (selectedList, selectedItem) => {
        if (this.multiselectPodName.current.state.selectedValues.length > 4) {
            this.setState({
                customerclass: true
            })
        }
        var obj = {};
        var selected_val = selectedItem.pod_name;

        obj['pod_name'] = selected_val;
        this.state.pods.push(obj);
    }

    onSelectFeature = (selectedList, selectedItem) => {
        
        let current_pods = this.state.pods ? this.state.pods : [];

        let current_products = this.state.ProductNameId ? this.state.ProductNameId : [];

        console.log(current_pods);

        console.log(current_products);

        if (this.multiselectFeatureName.current.state.selectedValues.length > 4) {
            this.setState({
                customerclass: true
            })
        }

        var obj = {};

        var selected_val = selectedItem.feature;

        var selected_ids = selectedItem.id;
        
        obj['feature'] = selected_val;

        obj['id'] = selected_ids;

        var feature_pods = selectedItem.pod;

        var feature_products = selectedItem.product;

        console.log(feature_pods);

        console.log(feature_products);

        if(Object.keys(feature_pods).length > 0){

            feature_pods.forEach((element) => {
               
                const found = current_pods.some(el => el.pod_name === element.pod_name);

                if (!found) current_pods.push(element);
            });

        }

        /*
        if(Object.keys(feature_products).length > 0){
            feature_products.forEach((element) => {
                const found = current_products.some(el => el.product_name === element.product_name);
                if (!found) current_products.push(element);
                
            });
        }
        */

        console.log(current_pods);

        console.log(current_products);

        this.setState({
           // ProductNameId: current_products,
            pods:current_pods
        })

        this.state.FeatureNameId.push(obj);
    }

    onRemove = (selectedList, removedItem) => {
        if (this.multiselectProductName.current.state.selectedValues.length < 4) {
            this.setState({
                customerclass: false
            })
        }
        var obj = {};
        var obj1 = {};
        var available_prod_arr = new Array();
        var available_prod = this.state.ProductNameId;
        var selected_remv = removedItem.product_name;
        available_prod_arr = available_prod.filter(function (obj) {
            return obj.product_name !== selected_remv;
        });
        this.setState({
            ProductNameId: available_prod_arr
        })
    }
    onRemovePod = (selectedList, removedItem) => {
        if (this.multiselectPodName.current.state.selectedValues.length < 4) {
            this.setState({
                customerclass: false
            })
        }
        var obj = {};
        var obj1 = {};
        var available_prod_arr = new Array();
        var available_prod = this.state.pods;
        var selected_remv = removedItem.pod_name;
        available_prod_arr = available_prod.filter(function (obj) {
            return obj.pod_name !== selected_remv;
        });
        this.setState({
            pods: available_prod_arr
        })
    }

    onRemoveFeature = (selectedList, removedItem) => {
        if (this.multiselectFeatureName.current.state.selectedValues.length < 4) {
            this.setState({
                customerclass: false
            })
        }

        var obj = {};
        var obj1 = {};
        var available_feature_arr = new Array();
        var available_feature = this.state.FeatureNameId;
        var selected_remv = removedItem.feature;
        available_feature_arr = available_feature.filter(function (obj) {
            return obj.feature !== selected_remv;
        });
        this.setState({
            FeatureNameId: available_feature_arr
        })

    }


    updateChatTranscript() {
        document.getElementById("add_chat_note").innerHTML = "Sending....";
        var nodes1 = document.querySelectorAll('input[type="hidden"].multi_tag');
        const fd = new FormData;
        
        for (let i in nodes1) {
            let value = nodes1[i].value;
            if (value !== null && typeof value !== "undefined" && value.trim() !== "") {
                fd.append("multi_tag[]", value);
            }
        }

        fetch(this.state.apiUrl + '/ErRest/updateChatTranscript/userAuthKey/' + this.state.userAuthKey, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
               // findresponse = this.decrypt(findresponse, 1);
                document.getElementById("add_chat_note").disabled = false;
                document.getElementById("add_chat_note").innerHTML = "update";
                if (findresponse.code == 200) {
                    this.setState({ message: findresponse.msg }, function () {
                        window.location.href = '/EditChat/' + this.props.match.params.transcriptId;
                    });
                } else {
                    this.setState({ message: findresponse.msg })
                }
            })
    }


    componentWillMount() {
        document.title = "Intranet | Edit Chat Transcript";
        if (!localStorage.getItem('userLogin')) {
            this.setState({ redirect: true });
        }
        this.getchatDetails();
    }


    onChange(propertyName, event) {
        if (propertyName == "status") {
            propertyName = event.target.value;
            this.setState({ status: propertyName });
        }
        if (propertyName == "visitor_name") {
            const visitor_name = this.state.visitor_name;
            propertyName = event.target.value;
            this.setState({ visitor_name: propertyName });
        }
        if (propertyName == "title") {
            const visitor_name = this.state.title;
            propertyName = event.target.value;
            this.setState({ title: propertyName });
        }
    }

    render() {
        if (this.state.redirect) {
            return (
                <Redirect to={'/login'} />
            )
        }

        return (
            <div>
                <Header brecum_name="Edit Chat Transcript" brecum_page="Edit Chat Transcript" ChatEdit={this.state.ChatEdit} />
                <div class="right_col">
                    <div class="loader-new"></div>
                    <div class="intranet_body update_chat_transcript hidden">
                        <div class="title mob"><HeaderMob page_name="Edit Chat Transcript" /></div>
                        <div class="top-row hidden-xs er_top">
                            <div class="pull-left">
                                <button type="button" className="btn btn-blue" onClick={() => this.goBack()} >Back</button>
                            </div>
                        </div>
                        <div class="top-row-form update_chat_row">
                            <div id="show_dialog">
                                <p>Sorry, transcript is not editable!! We can only highlight or unhighlight.</p>
                            </div>
                           
                            <div class="row mar_btm_16">
                                <div class="col-md-12">
                                    <label for="chat_trans">Transcript :</label>
                                    <CKEditor
                                        editor={ClassicEditor}
                                        data={this.state.ChatEdit ? this.state.ChatEdit : ""}
                                        onChange={(event, editor) => {
                                            const data = editor.getData();
                                            this.setState({ ChatEdit: data })
                                        }}
                                        onFocus={(event, editor) => {
                                            $('#cke_1_top').css('display', 'none');
                                        }}
                                    />
                                </div>
                            </div>
                            <div class="row mar_btm_16">
                                <div class="col-md-12">
                                    <label for="User_info" class = "mar_btm_16">Info:</label>
                                    <div class="chat_filed info-datas">
                                        <div class={"user_info collapse"} id={"collapseExample"}>
                                            <div class="form-group user_info_chld col-sm-12 col-xs-24">
                                                <label class="child_info">Email: </label>
                                                <div>{this.state.visitor_email ? this.state.visitor_email : "--NA--"}</div>
                                            </div>
                                            <div class="form-group user_info_chld col-sm-12 col-xs-24">
                                                <label class="child_info">IP Address: </label>
                                                <div>{this.state.visitor_ip ? this.state.visitor_ip : "--NA--"}</div>
                                            </div>
                                            <div class="form-group user_info_chld col-sm-12 col-xs-24">
                                                <label class="child_info">Location: </label>
                                                <div>{this.state.visitor_region ? this.state.visitor_region + ", " : ''}{this.state.visitor_city ? this.state.visitor_city + ", " : ''}{this.state.visitor_country_name ? this.state.visitor_country_name : ''}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row mar_btm_16">
                                <div class="col-md-6">
                                    <label for="lead">Summary :</label>
                                    <input type="text" name="title" id="title" className="form-control" value={this.state.title} onChange={this.onChange.bind(this, 'title')} />
                                </div>
                                <div class="col-md-6">
                                    <label >Lead Name :</label>
                                    <input type="text" name="lead" id="lead" className="form-control" value={this.state.visitor_name} onChange={this.onChange.bind(this, 'visitor_name')} />
                                </div>
                            </div>
                            <div class="row mar_btm_16">
                                <div class="col-md-4">
                                    <label >Features :</label>
                                    <div className={` filter ${this.state.customerclass || (this.state.count_feature > 4) ? 'class' : ''}`}>
                                        <Multiselect
                                            options={this.state.featurename}
                                            displayValue="feature"
                                            // onSelect={this.handleChange}
                                            onSelect={this.onSelectFeature.bind(this)}
                                            ref={this.multiselectFeatureName}
                                            onRemove={this.onRemoveFeature.bind(this)}
                                            selectedValues={this.state.FeatureNameId.map((item) => {
                                                return item == '' ? '' : item;
                                            })}
                                        />
                                    </div>
                                </div>

                                <div class="col-md-4">
                                    <label for="lead">PODs :</label>
                                    <div className={` filter ${this.state.customerclass || (this.state.count_pod > 4) ? 'class' : ''}`}>
                                        <Multiselect
                                            options={this.state.podname}
                                            displayValue="pod_name"
                                            // onSelect={this.handleChange}
                                            ref={this.multiselectPodName}
                                            onSelect={this.onSelectPod.bind(this)}
                                            onRemove={this.onRemovePod.bind(this)}
                                            selectedValues={this.state.pods.map((item) => {
                                                return item == '' ? '' : item;
                                            })}
                                        />
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <label >Products :</label>
                                    <div className={` filter ${this.state.customerclass || (this.state.count_prod > 4) ? 'class' : ''}`}>
                                        <Multiselect
                                            options={this.state.prodname}
                                            displayValue="product_name"
                                            // onSelect={this.handleChange}
                                            onSelect={this.onSelect.bind(this)}
                                            ref={this.multiselectProductName}
                                            onRemove={this.onRemove.bind(this)}
                                            selectedValues={this.state.ProductNameId.map((item) => {
                                                return item == '' ? '' : item;
                                            })}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="clear"></div>
                            <button type="submit" name="add_chat_note" id="add_chat_note" className="btn btn-sky mob-btn" onClick={() => this.updateChatTranscript()}>Update</button>
                        </div>
                        <div class="request_details">
                            <div id="exTab1" class="container title">
                                <ul class="nav nav-pills">
                                    <li class="active"><a href="#note" data-toggle="tab">Notes</a></li>
                                    <li><a href="#history" data-toggle="tab">History</a></li>
                                </ul>
                            </div>
                            <div class="tab-content customer-tab clearfix">
                                <div className="tab-pane active" id="note">
                                    <div class="row">
                                        <div className="form-section ckeditor">
                                            <CKEditor4
                                                activeClass="p10"
                                                name='note'
                                                content={this.state.note}
                                                events={{
                                                    "change": this.ckOnChange1
                                                }}
                                            />
                                            <div id='note_autoseggestion'></div>
                                            <span class="error">{this.state.errors["note"]}</span>
                                        </div>
                                        <div className="form-section ckeditor">
                                            <button type="submit" name="add_note" id="add_note" className="btn btn-sky mob-btn" onClick={() => this.AddNote()}>Add Note</button>
                                        </div>
                                    </div>
                                    <div className="feedback">
                                        {this.state.notes.length > 0 ?
                                            <h5 class="title"><span>View Note</span></h5>
                                            : ''}
                                        {
                                            this.state.notes.map((data, key) =>
                                                <div class="sub_feedback" id={'note' + data.id}>
                                                    <div class="main">
                                                        <div class="pro_image">
                                                            {this.state.formatted_owners[data.user_id].attachment_url ? <img src={this.state.formatted_owners[data.user_id].attachment_url + this.state.formatted_owners[data.user_id].attachment} /> : <span class="profile_first_name">{this.state.formatted_owners[data.user_id].img_name}</span>}
                                                        </div>
                                                        <div class="fa-icon tooltips">
                                                            {this.NoteEditCondition(data.id, data.note)}
                                                        </div>
                                                        <h6>{data.owner_name}</h6>
                                                        <span class="date">{data.created_date}</span>
                                                    </div>
                                                    <div class="sub">
                                                        <a href={'#note' + data.id} key={key} to={data.id} name={"max"}><span>Note {data.id}</span></a>
                                                        <div class="note_list" dangerouslySetInnerHTML={{ __html: data.note }} />
                                                    </div>
                                                </div>
                                            )
                                        }
                                    </div>
                                </div>
                                <div class="tickets tab-pane " id="history">
                                    <div className="feedback">
                                        {this.state.note_history.length > 0 ?
                                            <h5 class="title"><span>Chat Transcript History</span></h5>
                                            : ''}
                                        <ul class="tickets_head">
                                            <li class="intra_col_25">Date</li>
                                            <li class="intra_col_25">User</li>
                                            <li class="intra_col_25">Field</li>
                                            <li class="intra_col_25">Change</li>
                                        </ul>
                                        {
                                            this.state.note_history.map((ErHistory, key) =>
                                                <ul class="tickets_number">
                                                    <li class="intra_col_25">{ErHistory.created_date} </li>
                                                    <li class="intra_col_25">{this.state.formatted_owners[ErHistory.user_id].name}</li>
                                                    <li class="intra_col_25">{this.getHistoryTitle(ErHistory.type, ErHistory.old_value, ErHistory.new_value)}</li>
                                                    <li class="intra_col_25">{this.getHistoryDesc(ErHistory.type, ErHistory.old_value, ErHistory.new_value)}</li>
                                                </ul>
                                            )
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default UpdateChat;


// WEBPACK FOOTER //
// ./src/components/er/UpdateChat.js